import React, { useEffect } from 'react';
import { Button, Row, Col } from 'react-bootstrap';

import useGlobal from '../../store';
import UsuarioInfo from './info/UsuarioInfo';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import ResponseError from '../../shared/responses/ResponseError';
import PopConfirm from '../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../shared/responses/ResponseResult';
import UsuarioRolesForm from './upsert/components/UsuarioRolesForm';
import UsuarioPermissionsForm from './upsert/components/UsuarioPermissionsForm';

const UsuariosUpsertPermission = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { dataRouting = {} } = props.location.state || {};

  const { id } = props.match.params;

  useEffect(() => {
    actions.setInitialData(!!dataRouting.id ? { ...dataRouting } : { id });

    if (!dataRouting.nombre || id) {
      actions.getInfo(id, { include: 'permissions' });
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    let currentRole = '';
    const currentPermissions = {};

    if (state.info.data.roles && state.info.data.permissions) {
      for (const item of state.info.data.roles) {
        currentRole = item.id;
      }

      for (const item of state.info.data.permissions) {
        currentPermissions[item.id] = true;
      }

      handleOnChange({
        role: currentRole,
        selected: currentPermissions,
      });
    }
  }, [state.info.data]); // eslint-disable-line

  const handleOnReset = () => {
    actions.resetError({
      error: undefined,
    });
  };

  const handleOnAction = (action: string) => {
    if (action === 'cancel') {
      return;
    }

    actions.reset();

    props.history.replace('/app/usuarios');
    window.location.reload();
  };

  const handleSubmit = async (action, info) => {
    const { data } = state;

    const result = Object.entries(data.selected)
      .map(([key, value]) => {
        return !!value ? key : null;
      })
      .filter((a) => a);

    const body = {
      id: undefined,
      roles: [data.role],
      permisos: result,
    };

    actions.upsertPermissions(body, data.id);
  };

  const handleOnChange = (values) => {
    const { data } = state;

    const newData = {
      isValid: true,
      ...state,
      data: {
        ...data,
        ...values,
      },
    };

    actions.change(newData);
  };

  const handeOnClean = () => {
    actions.cleanInfo({});
  };

  const renderError = () => {
    const { error } = state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={handleOnReset}
        />
      </div>
    );
  };

  const renderResult = () => {
    const { result } = state;

    return (
      <div className="result-container">
        <ResponseResult
          title="Actualización exitosa"
          result={result}
          onAction={handleOnAction}
        />
      </div>
    );
  };

  const handleOnDeselectionClick = () => {
    handleOnChange({
      selected: {},
    });
  };

  const { data, error, result, busy, info } = state;
  const { busy: fetching } = info;
  const { isPermissionsValid = true } = data;

  if (fetching) {
    return <Loading />;
  }

  return (
    <>
      {!!error && renderError()}

      {!!result && renderResult()}

      <PageHeader
        text="Usuarios"
        to="/app/usuarios"
      />

      <Row>
        <Col>
          <h5>{info.data.nombre || '...'}</h5>
          <UsuarioInfo data={info.data} />
        </Col>
      </Row>

      <h5>Gestión de permisos</h5>

      <Row>
        <Col>
          <div className="py-3">
            <strong className="text-info">ROLES</strong>
          </div>

          <UsuarioRolesForm
            role={data.role}
            permissions={info.data.permissions || {}}
            onChange={handleOnChange}
            propietario={info.data.propietario}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="py-3">
            <strong className="text-info">PERMISOS</strong>
          </div>

          <div className="pb-3">
            <Button
              variant="secondary"
              onClick={handleOnDeselectionClick}
            >
              Deseleccionar todos los permisos
            </Button>
          </div>

          <UsuarioPermissionsForm
            selected={data.selected || {}}
            onClean={handeOnClean}
            onChange={handleOnChange}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <PopConfirm
            text="Quieres cancelar el registro actual?"
            onAction={handleOnAction}
          >
            <Button
              type="button"
              variant="secondary"
              disabled={busy}
              className="mr-3"
            >
              Cancelar
            </Button>
          </PopConfirm>

          <LoadingButton
            type="button"
            disabled={!isPermissionsValid}
            loading={busy}
            onClick={handleSubmit}
          >
            {!!data.id ? (busy ? 'Guardando...' : 'Guardar') : ''}
            {!data.id ? (busy ? 'Registrando...' : 'Registrar') : ''}
          </LoadingButton>
        </Col>
      </Row>
    </>
  );
};

const mapState = (state) => {
  return {
    ...state.app.usuarios.upsert,
    info: state.app.usuarios.info,
  };
};

const mapActions = (actions) => {
  const { usuarios } = actions.app;

  return {
    ...usuarios.upsert,
    getInfo: usuarios.info.info,
    getPermissions: usuarios.info.permissions,
    getRoles: usuarios.info.roles,
    cleanInfo: usuarios.info.change,
  };
};

export default UsuariosUpsertPermission;
